import { useState } from "react";
import { Link } from "react-router-dom";

import { Drawer, Title } from "@components";
import { Icon } from "@components/core/Icon";

import ROLES from "../data/Roles";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";
import styles from "../styles/settings.module.scss";

export default function Marketing() {
  const [openAlert, setOpenAlert] = useState(false);

  const checkRoles = (roles) => {
    let userRole = UserStorage.getLoggedUser()?.role;
    if (!userRole) userRole = ROLES.SHOPKEEPER;

    const allowRoute = roles.some((r) => r === userRole);

    return allowRoute;
  };

  const username = UserStorage.getLoggedUser()?.username

  const environment = EnvironmentStorage.getEnvironment();
  const pages = [
    {
      name: "Fluxos",
      icon: <i className="far fa-split" />,
      path: "/fluxos",
      enabled: checkRoles([
        ROLES.SUPPORT,
        ROLES.ADMIN,
        ROLES.MARKETING,
        ROLES.SAC
      ]),
    },
    {
      name: "Benefícios avulsos",
      icon: <i className="far fa-ticket-simple" />,
      path: "/beneficios",
      enabled: true,
    },
    {
      name: "Programa de fidelidade",
      icon: <i className="far fa-hand-holding-dollar" />,
      path: "/fidelidade",
      enabled: checkRoles([ROLES.SUPPORT, ROLES.MARKETING, ROLES.ADMIN]),
    },
    {
      name: "Avaliações",
      icon: <Icon name="fa-star" />,
      path: "/avaliacoes",
      enabled: checkRoles([
        ROLES.SUPPORT,
        ROLES.MARKETING,
        ROLES.ADMIN,
        ROLES.SAC,
      ]),
    },
    {
      name: "Mensageria",
      icon: <Icon name="fa-paper-plane" />,
      path: "/mensageria",
      enabled: checkRoles([ROLES.SUPPORT]),
    },
  ];

  const getSubtitle = () => {
    if (environment?.brand) return `${environment.brand.name}`;
    return environment?.name;
  };

  return (
    <div className={styles.settingsContainer}>
      <Title title="Fidelização e Marketing" />

      <div className={styles.settings}>
        {pages
          .filter((p) => !!p.enabled)
          .map((page, index) => {
            return (
              <Link to={page.path} key={index}>
                <div className={styles.setting} style={{ opacity: 1 }}>
                  <div className={styles.icon}>{page.icon}</div>
                  <p>{page.name}</p>
                </div>
              </Link>
            );
          })}
      </div>

      <Drawer
        visible={openAlert}
        onClose={() => setOpenAlert(false)}
        direction="center"
        title="Atenção"
        closeButton={false}
      >
        <p className={styles.message}>
          Esta página é acessível somente no modo unidade.
        </p>
      </Drawer>
    </div>
  );
}
